// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mPWH","placeholdersHeader":"styles_placeholdersHeader__3rbcT","editorStyle":"styles_editorStyle__1IlSB","placeholdersBox":"styles_placeholdersBox__2idkp"};